// extracted by mini-css-extract-plugin
module.exports = {"durationAndTempo":"TrackDurationAndTempo_durationAndTempo__VyR5P","detail":"TrackDurationAndTempo_detail__tTLBc bodyS"};